import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useHistory } from 'react-router'
import IconCard from '../../../common/IconCard'
import SectionHeader from '../../../common/SectionHeader'
import './style.sass'
import { useDispatch, useSelector } from 'react-redux'
import { getAllApplications } from '../../../../redux/actions/application'
import { getPendingReviews } from '../../../../redux/actions/release'
import LoadingBlock from '../../../common/LoadingBlock'
import SyncApplicationsModal from './components/SyncApplicationsModal'

const Dashboard = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  // Redux state
  const appList = useSelector(({ application }) => application.appList)
  const fetchingAppList = useSelector(({ application }) => application.fetchingAppList)
  const reviewList = useSelector(({ release }) => release.reviewList)
  const fetchingReviewList = useSelector(({ release }) => release.fetchingReviewList)

  // Local state
  const [isSyncAppModalVisible, setIsSyncAppModalVisible] = useState(false)

  useEffect(() => {
    dispatch(getAllApplications())
    dispatch(getPendingReviews())
  }, [])

  if (fetchingAppList || fetchingReviewList) {
    return <LoadingBlock message="Loading..." />
  }
  return (
    <div className="dashboard-page-container">
      <SectionHeader
        title="Admin Dashboard"
      />
      <Row>
        <Col sm={6}>
          <IconCard
            icon="check-circle"
            iconVarient="success"
            mainText={`${appList.length} applications`}
            mainButtonText="View"
            mainButtonOnClick={() => { history.push('/admin/all-applications') }}
          />
        </Col>
        <Col sm={6}>
          <IconCard
            icon="exclamation-circle"
            iconVarient="warn"
            mainText={`${reviewList.length} pending reviews`}
            mainButtonText="View"
            mainButtonOnClick={() => { history.push('/admin/pending-reviews') }}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <IconCard
            icon="refresh"
            iconVarient="refresh"
            mainText={`Sync applications`}
            mainButtonText="Sync Now"
            mainButtonOnClick={() => setIsSyncAppModalVisible(true)}
          />
          <SyncApplicationsModal 
            isVisible={isSyncAppModalVisible}
            setIsVisible={setIsSyncAppModalVisible}
          />
        </Col>
      </Row>
    </div>
  )
}

export default Dashboard



